module.exports = __webpack_public_path__ + "static/robe_of_the_archmagi-91eb0e33f9b2547ebf63d13458bc3231.jpeg";